import { SubHeading } from "./Typography";

export function Loading() {
  return <SubHeading>Loading...</SubHeading>;
}
